import { inject } from "vue";
import { useI18n } from "vue-i18n";
import { appConfigProviderKey } from "../../../infrastructure/app_config_provider";
import html_iway from "./template.iway.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: {},
  setup() {
    const { t, locale } = useI18n();
    const config = inject(appConfigProviderKey);

    const switchLang = function() {
      locale.value = locale.value === "en" ? "de" : "en";
    }
    return {
      t,
        config,
        switchLang
    };
  },
};
